import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Tabs, Tab } from 'react-bootstrap';
import MapBanner from './shared/MapBanner';
import CategoryExplorer from './events/CategoryExplorer';
import BestFriend from './shared/BestFriend';
import EventsCardsSlider from './events/EventsCardsSlider';
import AttractionsCardsSlider from './events/AttractionsCardsSlider';
import BwRewards from './events/BwRewards';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import { customerJourneyEventsCategories, customerJourneyEventsCategory, customerJourneyAttractions } from './../../actions';

const eventsTabIcon = require('./../../images/events_tab_icon.png');
const attractionsTabIcon = require('./../../images/attractions_tab_icon.png');

import './events.scss';

class Events extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentCategoryId: null
    };
  }

  /* Lifecycle */
  componentWillMount() {
    this.props.actions.customerJourneyAttractions(this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {

    const eventsTabLabel = (<span><img src={eventsTabIcon} alt="Events"/> {this.props.translate('events.events')}</span>);
    const attractionsTabLabel = (<span><img src={attractionsTabIcon} alt="Attractions"/> {this.props.translate('events.attractions')}</span>);

    const noEventsOrAttractions = (
      <div>
        <br/>
        <h2 className="text-center">{this.props.translate('events.no_events_or_attractions')}</h2>
        <br/>
      </div>
    );

    const eventsOrAttractions = (
        <AttractionsCardsSlider />
    );

    const eventsOrAttractionsPlaceholder = (
        <Tab eventKey="events" title={eventsTabLabel}>
          <AttractionsCardsSlider />
        </Tab>
    );

    return (
      <Grid className="events-component">

        <MapBanner header={this.props.translate('events.map_banner.header')}
                  title={this.props.translate('events.map_banner.title')}
                  text={this.props.translate('events.map_banner.text')}
                  zoom={12}
                  showPoi={true}/>
        {
          !this.props.loading
            ? this.props.attractionsCount > 0 ? eventsOrAttractions : noEventsOrAttractions
            : eventsOrAttractionsPlaceholder
        }

        <br/>
        <br/>
        <br/>

        <BwRewards/>

        <BestFriend/>

      </Grid>
    );
  }
}

Events.displayName = 'PagesEvents';
Events.propTypes = {};
Events.defaultProps = {};

const mapStateToProps = (state) => {
  return {
      token: state.commons.token,
      context: state.commons.context,
      translate: getTranslate(state.locale),
      eventsCategoriesCount: state.eventsCategories.apiData.length,
      attractionsCount: state.attractions.apiData.length,
      loading: state.eventsCategories.loading || state.attractions.loading
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyEventsCategories: bindActionCreators(customerJourneyEventsCategories, dispatch),
      customerJourneyEventsCategory: bindActionCreators(customerJourneyEventsCategory, dispatch),
      customerJourneyAttractions: bindActionCreators(customerJourneyAttractions, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);



// WEBPACK FOOTER //
// ./components/pages/Events.js